import Text from "./Text";
import Container from "./Container";

interface IAccordionHeaderProps {
    title: string;
    subTitle: string;
    endContent: React.ReactNode;
}

const AccordionHeader = ({ title, subTitle, endContent }: IAccordionHeaderProps) => {
    return (
        <Container wrapResponsive marginHorizontal="2" between gap={3}>
            <Container flexColumn gap={2}>
                <Text fontWeight="bold" color="white" size="lg">{title}</Text>
                <Text color="white" size="sm">{subTitle}</Text>
            </Container>

            <Container wrapResponsive gap={2}>
                {endContent}
            </Container>
        </Container>
    );
}

export default AccordionHeader;
